import { GET_DAILY_COLLECTIONS_REPORT } from '../../../Types'

const DailyCollectionsReportReducer = (state = [], action) => {
  switch (action.type) {
    case GET_DAILY_COLLECTIONS_REPORT:
      return action.payload

    default:
      return state
  }
}
export default DailyCollectionsReportReducer
